// extracted by mini-css-extract-plugin
export default {"itemContainer":"Bottom_itemContainer__OLjF9","itemHeading":"Bottom_itemHeading__bazEZ","itemContent":"Bottom_itemContent__dI+8Q","row":"Bottom_row__pA97T"};